<template>
	<div class="mapping-panel">
		<!-- 筛选 -->
		<div class="filter-bar">
			<el-input v-model="filter.delivery_no" placeholder="映射单号" clearable prefix-icon="el-icon-search"
				class="search-input filter-item"></el-input>
			<el-input v-model="filter.waybill_no" placeholder="佳成单号" clearable prefix-icon="el-icon-search"
				class="search-input filter-item"></el-input>
			<el-date-picker v-model="filter.date_range" type="daterange" range-separator="至"
				start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable
				class="search-input filter-item date-range-item"></el-date-picker>
			<el-select v-model="filter.status" placeholder="请选择状态" clearable
				class="search-input filter-item select-item">
				<el-option label="成功" :value="1"></el-option>
				<el-option label="失败" :value="2"></el-option>
			</el-select>
			<el-button type="primary" class="search-btn" @click="handleSearch">查询</el-button>
			<el-button class="reset-btn" @click="handleReset">重置</el-button>
			<el-button class="reset-btn export-btn" icon="el-icon-download" :loading="exporting"
				@click="handleExport">{{ exportLabel }}</el-button>
			<el-button class="reset-btn refresh-btn" icon="el-icon-refresh" :loading="loading"
				@click="handleRefresh">刷新</el-button>
		</div>

		<el-table :data="records" border style="width: 100%" v-loading="loading"
			class="mapping-table" :header-cell-style="{
				background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
				color: '#fff',
				fontWeight: '600',
				fontSize: '14px',
				padding: '12px 8px'
			}" :cell-style="{
				padding: '10px 8px',
				fontSize: '13px'
			}" @selection-change="handleSelectionChange">
			<el-table-column type="selection" width="50" align="center">
			</el-table-column>
			<el-table-column prop="merchant_order_no" label="商户订单号" align="center" min-width="190"></el-table-column>
			<el-table-column prop="delivery_no" label="映射单号" align="center" min-width="150"></el-table-column>
			<el-table-column prop="waybill_no" label="佳成单号" align="center" min-width="170">
				<template slot-scope="scope">
					<span v-if="scope.row.waybill_no">{{ scope.row.waybill_no }}</span>
					<span v-else style="color: #c0c4cc;">—</span>
				</template>
			</el-table-column>
			<el-table-column prop="status" label="状态" align="center" width="90">
				<template slot-scope="scope">
					<el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small" effect="plain">
						{{ scope.row.status === 1 ? '成功' : '失败' }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="error" label="失败原因" align="center" min-width="180">
				<template slot-scope="scope">
					<span v-if="scope.row.error" style="color: #cf1322;">{{ scope.row.error }}</span>
					<span v-else style="color: #c0c4cc;">—</span>
				</template>
			</el-table-column>
			<el-table-column prop="create_time" label="创建时间" align="center" min-width="170"></el-table-column>
		</el-table>

		<!-- 空数据提示 -->
		<div class="empty-mapping" v-if="records.length === 0 && !loading">
			<i class="el-icon-document" style="font-size: 40px; color: #c0c4cc; margin-bottom: 12px;"></i>
			<p style="font-size: 14px; color: #909399; margin: 0;">暂无映射单记录</p>
		</div>

		<!-- 分页 -->
		<div class="mapping-pagination" v-if="total > 0">
			<el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
				:current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 20, 50]"
				layout="total, sizes, prev, pager, next" :total="total" small></el-pagination>
		</div>
	</div>
</template>

<script>
import { formatDateTime as fmtDateTime } from '../utils/format';
import { exportCSV } from '../utils/export';

export default {
	name: 'MappingRecordsPanel',
	props: {
		userId: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			loading: false,
			exporting: false,
			records: [],
			selectedOrders: [],
			currentPage: 1,
			pageSize: 10,
			total: 0,
			filter: {
				delivery_no: '',
				waybill_no: '',
				date_range: [],
				status: ''
			}
		};
	},
	mounted() {
		this.loadRecords(1);
	},
	computed: {
		exportLabel() {
			if (this.selectedOrders.length > 0) {
				return '导出 Excel（已选 ' + this.selectedOrders.length + '）';
			}
			return '导出 Excel（' + this.total + '）';
		}
	},
	methods: {
		async apiRequest(url, data) {
			const response = await fetch(url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(data)
			});
			if (!response.ok) {
				throw new Error('请求失败: ' + response.status);
			}
			return response.json();
		},
		buildParams() {
			const range = this.filter.date_range || [];
			return {
				delivery_no: this.filter.delivery_no || '',
				waybill_no: this.filter.waybill_no || '',
				time_start: range[0] || '',
				time_end: range[1] || '',
				status: this.filter.status || 0
			};
		},
		async loadRecords(page) {
			if (page) this.currentPage = page;
			if (!this.userId || this.userId === 0) {
				this.$message.error('用户未登录或用户ID无效');
				return;
			}
			this.loading = true;
			try {
				const result = await this.apiRequest('/query_mapping.php', Object.assign({
					user_id: this.userId,
					page: this.currentPage,
					page_size: this.pageSize
				}, this.buildParams()));
				if (result.code === 200) {
					this.records = this.formatData(result.data.list || []);
					this.total = result.data.count || 0;
					this.$emit('count-changed', this.total);
				} else {
					this.$message.error(result.msg || '查询失败');
				}
			} catch (error) {
				console.error('查询映射单记录失败:', error);
				this.$message.error('网络错误或服务器异常，请稍后重试');
			} finally {
				this.loading = false;
			}
		},
		formatData(list) {
			return list.map(item => {
				const status = parseInt(item.status || 0, 10);
				return {
					id: item.id,
					merchant_order_no: item.merchant_order_no || '',
					delivery_no: item.delivery_no || '',
					waybill_no: item.waybill_no || '',
					status: status,
					error: item.error || '',
					create_time: fmtDateTime(item.created_at)
				};
			});
		},
		handleCurrentChange(page) {
			this.loadRecords(page);
		},
		handleSizeChange(size) {
			this.pageSize = size;
			this.loadRecords(1);
		},
		handleSearch() {
			this.loadRecords(1);
		},
		handleReset() {
			this.filter = {
				delivery_no: '',
				waybill_no: '',
				date_range: [],
				status: ''
			};
			this.loadRecords(1);
		},
		handleRefresh() {
			this.loadRecords(this.currentPage);
		},
		handleSelectionChange(selection) {
			this.selectedOrders = selection;
		},
		async handleExport() {
			if (this.exporting) return;
			this.exporting = true;
			try {
				let all = [];
				if (this.selectedOrders.length > 0) {
					// 有勾选：只导出勾选的行
					all = this.selectedOrders.map(r => ({
						merchant_order_no: r.merchant_order_no,
						delivery_no: r.delivery_no,
						waybill_no: r.waybill_no,
						status: r.status,
						error: r.error,
						created_at: r.create_time,
						_formatted: true
					}));
				} else {
					// 未勾选：提示后导出当前筛选条件下的全部
					try {
						await this.$confirm('未勾选映射单，将导出当前查询条件下的全部记录，是否继续？', '提示', {
							confirmButtonText: '继续导出',
							cancelButtonText: '取消',
							type: 'warning'
						});
					} catch (e) {
						this.$message.info('已取消导出');
						return;
					}
					const base = Object.assign({ user_id: this.userId, page_size: 500 }, this.buildParams());
					let page = 1;
					let lastCount = 500;
					do {
						const result = await this.apiRequest('/query_mapping.php', Object.assign({}, base, { page }));
						const d = result.data || {};
						const list = d.list || [];
						all = all.concat(list);
						lastCount = list.length;
						page++;
					} while (lastCount === 500 && page <= 1000);
				}
				const rows = all.map((it) => [
					it.merchant_order_no || '',
					it.delivery_no || '',
					it.waybill_no || '',
					parseInt(it.status || 0, 10) === 1 ? '成功' : '失败',
					it.error || '',
					it._formatted ? (it.created_at || '') : (it.created_at ? fmtDateTime(it.created_at) : '')
				]);
				exportCSV('映射单记录_' + Date.now() + '.csv',
					['商户订单号', '映射单号', '佳成单号', '状态', '失败原因', '创建时间'], rows);
			} catch (e) {
				this.$message.error('导出失败：' + e.message);
			} finally {
				this.exporting = false;
			}
		}
	}
};
</script>

<style scoped>
.mapping-panel {
	padding: 16px;
	background: #fff;
	border: 1px solid #e8ecf4;
	border-radius: 14px;
}
.filter-bar {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 10px;
	margin-bottom: 16px;
}
.filter-item {
	width: 160px;
}
.date-range-item {
	width: 240px;
}
.select-item {
	width: 140px;
}
.search-btn,
.reset-btn {
	min-width: 80px;
}
.export-btn {
	background: #e8f1ff;
	border-color: #a8c8f0;
	color: #3a7bd5;
}
.export-btn:hover {
	background: #d7e8ff;
	border-color: #7fa9e8;
	color: #2f6ac0;
}
.refresh-btn {
	margin-left: auto;
}
.empty-mapping {
	text-align: center;
	padding: 40px 0;
}
.mapping-pagination {
	display: flex;
	justify-content: flex-end;
	margin-top: 16px;
}
</style>
